/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import urls from '../../constants/urls.js';
import articleTypes from '../../constants/articleTypes';

const BlogSummaryItem = ({item, articleType}) => { 

    const getLink = () => {
        const prefix = articleType === articleTypes.general ? 'Blog' : 'Unsigned';
        return `/${prefix}/${item.Link}`;
    };

    const getIntroRaw = () => {
        return {__html: item.Intro};
    };

    const getImage = (params) => {
        return urls.USER_IMAGES_BASE_URL + item.ImageUrl + (params || '');
    };

    return (
        <article className="blogpost">
            <header>
                <h1>
                    <Link to={getLink()} className="transition">{item.Title}</Link>
                </h1>
                <p className="spec">
                    <span className="sections">
                        {
                            item.Sections.map(section =>
                                <a key={section} href={null} className="sect transition">{section}</a>
                            )
                        }
                    </span> 
                    <em>By <Link to={`/${item.AuthorUsername}`}>{item.AuthorDisplayName}</Link></em>
                </p>
            </header>
            <div className="blogbody">
                {
                    item.ImageUrl ?
                    <div className="blogimg">
                        <Link to={getLink()}>
                            <img className="img-responsive" src={getImage('?width=527&maxheight=420&quality=80&mode=crop&scale=both&format=jpg')} alt={item.Title} />
                        </Link>
                    </div>
                    : null
                }               
                <p className="intro" dangerouslySetInnerHTML={getIntroRaw()} />
                <Link to={getLink()} className="btn btn-primary btn-dark transition">CONTINUE READING
                    <svg className="icon icn-carret transition">
                        <use xlinkHref="#icn-carret" />
                    </svg>
                </Link>
            </div>
        </article>  
    );
};

export default BlogSummaryItem;

BlogSummaryItem.propTypes = {
    articleType: PropTypes.string.isRequired,
    item: PropTypes.object
};